import { CloseOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Spin,
} from 'antd'
import { runInAction } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { ButtonFooter } from '../WorkPage/PopupWorkForm/PopupWorkFormStyled'
import ManagerInventorySortableLevels from './ManagerInventorySortableLevels'
import { AddButton, ManagerInventoryLevel } from './ManagerInventoryStyles'
import validator from '../../validator'
import ManagerInventoryLevelCreate from './ManagerInventoryLevelCreate'

export const getInfoUser = (username, departmentWithUserList) => {
  const user = {
    full_name: username,
    image_id: null,
    username: username,
  }
  departmentWithUserList.forEach(department => {
    const userTarget = department.users.find(
      user => user.user_name === username
    )

    if (userTarget) {
      user.full_name = userTarget.name_uppercase || username
      user.image_id = userTarget.image_id
    }
  })
  return user
}

const ManagerInventoryUpdate = props => {
  const [form] = Form.useForm()

  const [isVisibleLevelCreateModal, setIsVisibleLevelCreateModal] = useState(
    false
  )
  const [checkAddMore, setCheckAddMore] = useState(true)
  const {
    managerInventoryStore,
    selectPeopleStore,
    authenticationStore,
  } = props

  const { originDepartmentWithUserList, companyCode } = selectPeopleStore
  const { managerInventoryDetail } = managerInventoryStore

  const [isUpdating, setIsUpdating] = useState(false)

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    getApprovalTemplateDetail(props.templateId)

    return () => managerInventoryStore.clearManagerInventoryDetail()
  }, [props.templateId])

  useEffect(() => {
    form.setFieldsValue({
      name: managerInventoryDetail.name,
      description: managerInventoryDetail.description,
    })

    runInAction(() => {
      managerInventoryStore.managerInventoryListLevels = managerInventoryDetail.approval_levels
        .slice(1)
        .map(tempLevel => {
          const handler = getInfoUser(
            tempLevel.username,
            originDepartmentWithUserList
          )
          return {
            level: tempLevel.level,
            code: tempLevel.code,
            name: tempLevel.name,
            allow_edit: tempLevel.allow_edit,
            is_deleted: false,
            handler: {
              full_name: handler.full_name,
              username: handler.username,
            },
          }
        })
    })

    return () => managerInventoryStore.clearManagerInventoryListLevels()
  }, [managerInventoryDetail])
  const [countLevelCreateModal, setCountLevelCreateModal] = useState(0)
  useEffect(() => {
    setCountLevelCreateModal(
      managerInventoryStore.managerInventoryListLevels.length
    )
  }, [managerInventoryDetail])
  useEffect(() => {
    countLevelCreateModal >= 5 ? setCheckAddMore(false) : setCheckAddMore(true)
  }, [countLevelCreateModal])

  const getApprovalTemplateDetail = async id => {
    try {
      setIsLoading(true)
      await managerInventoryStore.getManagerInventoryDetail(id)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleToggleLevelCreateModal = bool => event => {
    setIsVisibleLevelCreateModal(bool)
    if (!bool) {
      selectPeopleStore.clearSelected()
    }
  }

  const onFinish = async value => {
    try {
      setIsUpdating(true)

      let level = 0

      if (
        managerInventoryStore.managerInventoryListLevels.filter(
          level => !level.is_deleted
        ).length === 0
      ) {
        message.error('Số cấp duyệt phải từ 1 cấp trở lên')
        return
      }

      const approvalTemplate = {
        name: value.name.replace(/\s+/g, ' ').trim(),
        description: value.description.trim(),
        approval_levels: [
          managerInventoryStore.managerInventoryDetail.approval_levels[0],
          ...managerInventoryStore.managerInventoryListLevels.map(
            approvalLevel => {
              if (!approvalLevel.is_deleted) level += 1

              return {
                code: approvalLevel.is_temp ? null : approvalLevel.code,
                level: approvalLevel.is_deleted ? approvalLevel.level : level,
                name: approvalLevel.name.replace(/\s+/g, ' ').trim(),
                allow_edit: approvalLevel.allow_edit,
                username: approvalLevel.handler?.username,
                is_deleted: approvalLevel.is_deleted,
              }
            }
          ),
        ],
        template_type: 'asset',
      }

      await managerInventoryStore.updateManagerInventory(
        props.templateId,
        approvalTemplate
      )
      message.success('Chỉnh sửa cấp duyệt thành công')
      props.onCancel()
      // await managerInventoryStore.getManagerInventorytList()
      await managerInventoryStore.getManagerInventoryLists()
    } catch (error) {
      console.log(error)
      message.error('Chỉnh sửa cấp duyệt không thành công')
      props.onCancel()
    } finally {
      setIsUpdating(false)
    }
  }
  return (
    <>
      <Form onFinish={onFinish} form={form} layout="vertical">
        <Spin spinning={isLoading}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <Form.Item
                label={'Tên:'}
                name={'name'}
                rules={[
                  { required: true, message: 'Vui lòng nhập tên cấp duyệt' },
                  {
                    max: 500,
                    message: 'Tên cấp duyệt không được dài quá 500 ký tự!',
                  },
                  { validator: validator.validateInputString },
                ]}>
                <Input placeholder={'Nhập tên cấp duyệt...'} />
              </Form.Item>

              <Form.Item
                name={'description'}
                label={'Mô tả:'}
                rules={[
                  { required: true, message: 'Vui lòng nhập mô tả cấp duyệt!' },
                  { validator: validator.validateInputString },
                ]}>
                <Input.TextArea rows={4} placeholder={'Nhập mô tả cấp duyệt'} />
              </Form.Item>
            </Col>

            <Col span={16}>
              <p style={{ fontWeight: 500, marginBottom: 9 }}>Cấp độ duyệt</p>

              <ManagerInventoryLevel>
                <Row style={{ justifyContent: 'flex-end', marginBottom: 0 }}>
                  <Col span={22} className="approval-level__content">
                    <dt>Tên</dt>
                    <dd>Bộ phận đề nghị</dd>
                    <dt>Người xử lý</dt>
                    <dd>Mặc định</dd>
                  </Col>
                </Row>
              </ManagerInventoryLevel>

              <ManagerInventorySortableLevels
                countLevelCreateModal={countLevelCreateModal}
                setCountLevelCreateModal={setCountLevelCreateModal}
              />
              {checkAddMore ? (
                <AddButton onClick={handleToggleLevelCreateModal(true)}>
                  <PlusOutlined size={18} />
                  Thêm cấp duyệt
                </AddButton>
              ) : (
                <div style={{ color: 'red', textAlign: 'right' }}>
                  * Đã đạt mức tối đa 5 cấp duyệt
                </div>
              )}
            </Col>
          </Row>
        </Spin>
        <ButtonFooter>
          <Space>
            <Button icon={<CloseOutlined />} danger onClick={props.onCancel}>
              Đóng
            </Button>
            <Button
              icon={<EditOutlined />}
              type={'primary'}
              htmlType={'submit'}
              loading={isUpdating}>
              Lưu
            </Button>
          </Space>
        </ButtonFooter>
      </Form>

      <Modal
        width={800}
        title={'Thêm cấp duyệt'}
        visible={isVisibleLevelCreateModal}
        maskClosable={false}
        onCancel={handleToggleLevelCreateModal(false)}
        footer={null}
        destroyOnClose>
        {isVisibleLevelCreateModal && (
          <ManagerInventoryLevelCreate
            onCancel={handleToggleLevelCreateModal(false)}
            countLevelCreateModal={countLevelCreateModal}
            setCountLevelCreateModal={setCountLevelCreateModal}
          />
        )}
      </Modal>
    </>
  )
}
export default inject(
  'managerInventoryStore',
  'selectPeopleStore',
  'authenticationStore'
)(observer(ManagerInventoryUpdate))
